// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.accounting.CopyFeeScheduleRangeRequest */
/* istanbul ignore next */
@GandalfModel
export class CopyFeeScheduleRangeRequest extends GandalfModelBase {

	@GandalfLabel('Begin Date')
	@GandalfProperty({ designType: Date })
	beginDate!: Date;

	@GandalfLabel('Fee Schedule')
	@GandalfValidator({ notNull: { message: 'Fee Schedule is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	destinationFeeScheduleId!: number;

	@GandalfLabel('Fee Schedule Range')
	@GandalfValidator({ notNull: { message: 'Fee Schedule Range is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfLabel('Location')
	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfLabel('Write Off Reason')
	@GandalfValidator({ notNull: { message: 'Write Off Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	writeoffReasonId!: number;

}
